module.exports = __webpack_public_path__ + "img/arrow-left.c0615edc.svg";